import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import HeaderCreateDocument from '../../components/layout/createDocument/Header';
import { useAuth } from '../../shared/context';
import { Outlet } from 'react-router-dom';

const CreateDocument = () => {
  // const [index, setIndex] = useState(0);
    const { checkTokenValidity } = useAuth();

    useEffect(() => {
      checkTokenValidity();
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
          <HeaderCreateDocument />
        </Grid>
        <Grid item xs={12}>
          <Outlet />
        </Grid>
      </Grid>
    );
};

export default CreateDocument;
